import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " 採時駅が停車駅の場合、自動的に1分追加した所要時間で計算します ", -1)
const _hoisted_2 = { class: "flex justify-content-center" }
const _hoisted_3 = { class: "inline-flex flex-column" }
const _hoisted_4 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: "停車駅設定",
    modal: true,
    dismissableMask: true,
    visible: _ctx.localVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localVisible) = $event)),
    onHide: _ctx.onHide
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "確定",
        onClick: _ctx.onClick
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stationList, (station, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: station.id,
              class: "inline-block mb-1"
            }, [
              _createVNode(_component_Checkbox, {
                id: `station${station.id}`,
                value: station.id,
                key: station.id,
                modelValue: _ctx.stoppingStationList,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stoppingStationList) = $event)),
                class: "mx-2",
                disabled: idx === 0 || idx === _ctx.stationList.length - 1
              }, null, 8, ["id", "value", "modelValue", "disabled"]),
              _createElementVNode("label", {
                for: `station${station.id}`
              }, _toDisplayString(station.name), 9, _hoisted_4)
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}